import { gql } from 'graphql-request'

export const GET_GIFT_SENT_RANKING_HOST_BY_LIVE_BETWEEN_DATE = gql`
  query GET_GIFT_SENT_RANKING_HOST_BY_LIVE_BETWEEN_DATE(
    $initialDate: String
    $finalDate: String
    $liveId: Int
  ) {
    getGiftSentRankingHostByLiveBetweenDate(
      initialDate: $initialDate
      finalDate: $finalDate
      liveId: $liveId
    ) {
      status
      error
      data {
        userReceivedId
        liveId
        userUsername
        userImgUser
        userGender
        userCountry
        userBirthday
        levelHostId
        levelHostGradientColor
        levelSpectatorId
        levelGradientColor
        quantity
        invisibleGiftGiver
      }
    }
  }
`

export const GET_MULTI_LIVE_TROPHY = gql`
  query GET_MULTILIVE_TROPHY(
    $initialDate: String
    $finalDate: String
    $typeLive: String
    $userReceivedId: Int
  ) {
    getMultiLiveTrophy(
      initialDate: $initialDate
      finalDate: $finalDate
      typeLive: $typeLive
      userReceivedId: $userReceivedId
    ) {
      error
      status
      data {
        quantity
      }
    }
  }
`

export const GET_GIFT_SENT_RANKING_SPECTATOR_BY_LIVE_BETWEEN_DATE = gql`
  query GET_GIFT_SENT_RANKING_SPECTATOR_BY_LIVE_BETWEEN_DATE(
    $initialDate: String
    $finalDate: String
    $liveId: Int
  ) {
    getGiftSentRankingSpectatorByLiveBetweenDate(
      initialDate: $initialDate
      finalDate: $finalDate
      liveId: $liveId
    ) {
      status
      error
      data {
        userSentId
        liveId
        userUsername
        userGender
        userBirthday
        userCountry
        levelSpectatorId
        levelGradientColor
        levelHostId
        levelHostGradientColor
        userImgUser
        quantity
        invisibleGiftGiver
      }
    }
  }
`

export const GET_LIVE_POINTS = gql`
  query GET_LIVE_POINTS($liveId: Int!) {
    getLive(liveId: $liveId) {
      error
      status
      data {
        points
      }
    }
  }
`
